/**
 * @flow
 * @relayHash 5d444e2bcd4b13272bc5a6dbda460ae3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountEventPage_viewer$ref = any;
type BookPreviewPage_viewer$ref = any;
export type AccountEventPageQueryRendererQueryVariables = {|
  eventId: string,
  isRecheckPage: boolean,
|};
export type AccountEventPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AccountEventPage_viewer$ref & BookPreviewPage_viewer$ref
  |}
|};
export type AccountEventPageQueryRendererQuery = {|
  variables: AccountEventPageQueryRendererQueryVariables,
  response: AccountEventPageQueryRendererQueryResponse,
|};
*/


/*
query AccountEventPageQueryRendererQuery(
  $eventId: ID!
  $isRecheckPage: Boolean!
) {
  viewer {
    ...AccountEventPage_viewer
    ...BookPreviewPage_viewer
    id
  }
}

fragment AccountEventPage_viewer on Viewer {
  account {
    orders(first: 100) {
      edges {
        node {
          id
          cart {
            lineItems {
              product {
                event {
                  name
                  sgId
                  id
                }
                id
              }
              id
            }
            id
          }
          orderid
          vouchers {
            id
            code
            campaign {
              id
              banner
              url
            }
          }
        }
      }
    }
    boughtEvent(eventId: $eventId) {
      name
      products {
        type
        price
        id
      }
      sgId
      shortName
      searchByFace
      ...EventInfoCard_eventInfo
      id
    }
    eventPurchases(byStartnumber: true, eventId: $eventId) {
      availableCertificates
      availableVideos
      availableZips
      bonusMedia {
        mediaInfo {
          count
        }
        mediaList(first: 1000) {
          edges {
            node {
              id
              sgId
              variants {
                format
                name
                url
                id
              }
            }
          }
          ...MediaList_media
        }
      }
      canRestart
      restartState
      participants {
        media {
          mediaInfo {
            count
          }
          mediaList(first: 1000) {
            edges {
              node {
                id
                sgId
                variants {
                  format
                  name
                  url
                  id
                }
              }
            }
            ...MediaList_media
          }
        }
        startnumber
      }
      singleMedia {
        mediaInfo {
          count
        }
        mediaList(first: 1000) {
          edges {
            node {
              id
              sgId
              variants {
                format
                name
                url
                id
              }
            }
          }
          ...MediaList_media
        }
      }
    }
    id
  }
}

fragment BookPreviewPage_viewer on Viewer {
  account {
    boughtEvent(eventId: $eventId) {
      fotoBookTemplate
      name
      products {
        configuration {
          __typename
          ... on FotoBookConfiguration {
            variants {
              languages
            }
          }
        }
        id
        price
        type
      }
      sgId
      shortName
      id
    }
    eventPurchases(byStartnumber: true, eventId: $eventId) {
      bonusMedia {
        mediaList(first: 1000) {
          edges {
            node {
              id
              name
              sgId
              variants {
                format
                name
                url
                id
              }
            }
          }
        }
      }
      participants {
        media {
          mediaList(first: 1000) {
            edges {
              node {
                id
                name
                sgId
                variants {
                  format
                  name
                  url
                  id
                }
              }
            }
          }
        }
      }
      singleMedia {
        mediaList(first: 1000) {
          edges {
            node {
              id
              name
              sgId
              variants {
                format
                name
                url
                id
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment EventInfoCard_eventInfo on Event {
  id
  sgId
  beginsAt
  banner
  hostHomepageName
  hostHomepageUrl
  location
  name
  predecessorEvent {
    name
    id
  }
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      recheckStatus @include(if: $isRecheckPage)
  recheckRequestedAt @include(if: $isRecheckPage)
      ...MediaListItem_item
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isRecheckPage",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "banner",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "eventId",
  "variableName": "eventId"
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mediaInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "count",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mediaList",
    "storageKey": "mediaList(first:1000)",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      }
    ],
    "concreteType": "MediaConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Media",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "variants",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "format",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shotDate",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isRecheckPage",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recheckStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recheckRequestedAt",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AccountEventPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AccountEventPage_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "BookPreviewPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountEventPageQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "account",
            "storageKey": null,
            "args": null,
            "concreteType": "Account",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "orders",
                "storageKey": "orders(first:100)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  }
                ],
                "concreteType": "OrderConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Order",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "lineItems",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LineItem",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "product",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "event",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v3/*: any*/),
                                          (v1/*: any*/)
                                        ]
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "orderid",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vouchers",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Voucher",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "code",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "campaign",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "VoucherCampaign",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "boughtEvent",
                "storageKey": null,
                "args": [
                  (v6/*: any*/)
                ],
                "concreteType": "Event",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "price",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "configuration",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "FotoBookConfiguration",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "variants",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FotoBookVariants",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "languages",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "searchByFace",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "beginsAt",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hostHomepageName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hostHomepageUrl",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "predecessorEvent",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Event",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fotoBookTemplate",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "eventPurchases",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "byStartnumber",
                    "value": true
                  },
                  (v6/*: any*/)
                ],
                "concreteType": "EventPurchases",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableCertificates",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableVideos",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableZips",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bonusMedia",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canRestart",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "restartState",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participants",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BoughtParticipant",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "media",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExtendedMediaConnection",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "startnumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "singleMedia",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "AccountEventPageQueryRendererQuery",
    "id": null,
    "text": "query AccountEventPageQueryRendererQuery(\n  $eventId: ID!\n  $isRecheckPage: Boolean!\n) {\n  viewer {\n    ...AccountEventPage_viewer\n    ...BookPreviewPage_viewer\n    id\n  }\n}\n\nfragment AccountEventPage_viewer on Viewer {\n  account {\n    orders(first: 100) {\n      edges {\n        node {\n          id\n          cart {\n            lineItems {\n              product {\n                event {\n                  name\n                  sgId\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          orderid\n          vouchers {\n            id\n            code\n            campaign {\n              id\n              banner\n              url\n            }\n          }\n        }\n      }\n    }\n    boughtEvent(eventId: $eventId) {\n      name\n      products {\n        type\n        price\n        id\n      }\n      sgId\n      shortName\n      searchByFace\n      ...EventInfoCard_eventInfo\n      id\n    }\n    eventPurchases(byStartnumber: true, eventId: $eventId) {\n      availableCertificates\n      availableVideos\n      availableZips\n      bonusMedia {\n        mediaInfo {\n          count\n        }\n        mediaList(first: 1000) {\n          edges {\n            node {\n              id\n              sgId\n              variants {\n                format\n                name\n                url\n                id\n              }\n            }\n          }\n          ...MediaList_media\n        }\n      }\n      canRestart\n      restartState\n      participants {\n        media {\n          mediaInfo {\n            count\n          }\n          mediaList(first: 1000) {\n            edges {\n              node {\n                id\n                sgId\n                variants {\n                  format\n                  name\n                  url\n                  id\n                }\n              }\n            }\n            ...MediaList_media\n          }\n        }\n        startnumber\n      }\n      singleMedia {\n        mediaInfo {\n          count\n        }\n        mediaList(first: 1000) {\n          edges {\n            node {\n              id\n              sgId\n              variants {\n                format\n                name\n                url\n                id\n              }\n            }\n          }\n          ...MediaList_media\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BookPreviewPage_viewer on Viewer {\n  account {\n    boughtEvent(eventId: $eventId) {\n      fotoBookTemplate\n      name\n      products {\n        configuration {\n          __typename\n          ... on FotoBookConfiguration {\n            variants {\n              languages\n            }\n          }\n        }\n        id\n        price\n        type\n      }\n      sgId\n      shortName\n      id\n    }\n    eventPurchases(byStartnumber: true, eventId: $eventId) {\n      bonusMedia {\n        mediaList(first: 1000) {\n          edges {\n            node {\n              id\n              name\n              sgId\n              variants {\n                format\n                name\n                url\n                id\n              }\n            }\n          }\n        }\n      }\n      participants {\n        media {\n          mediaList(first: 1000) {\n            edges {\n              node {\n                id\n                name\n                sgId\n                variants {\n                  format\n                  name\n                  url\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n      singleMedia {\n        mediaList(first: 1000) {\n          edges {\n            node {\n              id\n              name\n              sgId\n              variants {\n                format\n                name\n                url\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventInfoCard_eventInfo on Event {\n  id\n  sgId\n  beginsAt\n  banner\n  hostHomepageName\n  hostHomepageUrl\n  location\n  name\n  predecessorEvent {\n    name\n    id\n  }\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      recheckStatus @include(if: $isRecheckPage)\n  recheckRequestedAt @include(if: $isRecheckPage)\n      ...MediaListItem_item\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'de8008232d875c903db8171ae78cfbb5';

module.exports = node;
